export default __webpack_public_path__ + "static/media/abb-cylon.4a64d226.webp";